import type { LoopClip } from './types'
import { createDefaultClips } from '../utils/clipUtils'
import { convertAiffToWav, isAiffFile } from '../utils/aiffConverter'

export interface SimpleLoopImportResult {
  buffer: AudioBuffer
  clips: LoopClip[]
}

export async function handleSimpleLoopImport(
  file: File,
  audioContext: AudioContext,
  totalSteps: number = 32,
): Promise<SimpleLoopImportResult> {
  let arrayBuffer = await file.arrayBuffer()

  if (isAiffFile(file)) {
    arrayBuffer = await convertAiffToWav(arrayBuffer)
  }

  const buffer = await audioContext.decodeAudioData(arrayBuffer.slice(0))
  const clips = createDefaultClips(totalSteps)

  // Optional: calculate audioOffset in samples based on bpm if needed
  return { buffer, clips }
}
